import { NewsVm } from "../../../utils/api";
import NewsShort from './NewsShort';

interface OwnProps {
    news: NewsVm;
}

export type Props = OwnProps;

export default NewsShort